<template>
  <router-view v-slot="{ Component, route }">
    <keep-alive>
      <component
          :is="Component"
          v-if="route.meta.keepAlive"
          :key="route.fullPath"
      />
    </keep-alive>
    <component
        :is="Component"
        v-if="!route.meta.keepAlive"
        :key="route.fullPath"
    />
  </router-view>
</template>

<script setup>// 保持简单，只根据路由 meta 信息决定是否启用 keepAlive
</script>


<style>
/* 全局样式可以保留在这里 */
/*#app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}*/
#app {
background-color: #fff;
}
/* 管线信息浮动面板样式 */
.pipeline-info-panel {
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
/* 面板头部样式 */
.panel-header {
  display: flex; 
  justify-content: space-between;
  align-items: center;
  padding: 4px 25px;
  border-bottom: 1px solid #eee;
  position: relative;
  margin: -10px -10px 10px -10px;
  background: linear-gradient(to right, #ffffff, #f0f8ff);
}
.panel-title {
  font-size: 16px;
  font-weight: bold;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 280px;
}
/* 使用深度选择器确保样式能应用到子组件 */
.close-btn {
  font-size: 26px !important;
  color: #999 !important;
  padding: 5px !important;
  margin-left: auto;
}
</style>